<template>
  <div>
    <!-- 银行流水管理 -->
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>来账流水管理</span>
          </div>
          <div class="right">
            <!-- 所属机构 -->
            <DepartmentChoose :department-code.sync="paramsData.departmentCode"
                              @change="departmentIdchange"></DepartmentChoose>

            <!--选择商户-->
            <a-select
                v-model="paramsData.merchantNo"
                placeholder="请选择商户"
                show-search
                option-filter-prop="children"
                allow-clear
                style="min-width: 300px;margin-right:50px"
            >
              <a-select-option
                  v-for="merchant in mainMerchantList"
                  :key="merchant.merchantNo"
                  :value="merchant.merchantNo"
              >
                {{ merchant.merchantName }} ({{ merchant.merchantNo }})
              </a-select-option>
            </a-select>


          </div>
        </div>
      </template>
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>流水号</span>
          <a-input v-model.trim="paramsData.bankSerialNo" placeholder="请输入流水号" allow-clear/>
        </div>

        <div class="item">
          <span>付款账号</span>
          <a-input v-model.trim="paramsData.oppAccountNo" placeholder="请输入付款账号" allow-clear/>
        </div>

        <div class="item">
          <span>付款户名</span>
          <a-input v-model.trim="paramsData.oppAccountName" placeholder="请输入付款户名" allow-clear/>
        </div>

        <div class="item">
          <span>状态</span>
          <a-select v-model.trim="paramsData.status" placeholder="请选择状态" allow-clear>
            <a-select-option v-for="(type, value) in  commonDict.flow_status" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>

        <div class="item">
          <span>来账时间</span>
          <a-range-picker
              v-model="tradeDateRange"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="onDateChange"
          />
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 操作按钮区域 -->
      <div class="tableBox">
        <div class="handleBtn">
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.bankSerialNo"
              :scroll="{ x: 1500 }"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <!-- 操作按钮 -->
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <!-- 匹配按钮  -->
<!--                <a-button icon="link" style="color: #52c41a;" type="link" @click="matchBtn(record)" v-if="record.status === '0' && $authority('bankFlowMatch')">匹配</a-button>-->
                <!-- 取消匹配按钮 -->
<!--                <a-button icon="disconnect" style="color: #722ed1;" type="link" @click="cancelMatchBtn(record)" v-if="record.status === '1' && $authority('bankFlowCancelMatch')">取消匹配</a-button>-->
                <!-- 分账确认按钮  -->
<!--                <a-button icon="bars" style="color: #fa8c16;" type="link" @click="genPlanTryBtn(record)" v-if="record.status === '1' && $authority('bankFlowConfirm')">分账确认</a-button>-->
                <!-- 立即清分按钮  -->
<!--                <a-button icon="fork" style="color: #1890ff;" type="link" @click="settlementBtn(record)" v-if="record.status === '2' && $authority('bankFlowSettle')">立即清分</a-button>-->
                <!-- 查看按钮 -->
                <a-button icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)" v-if="$authority('bankFlowView')">查看</a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <LcfsPagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"
                        :fn="getTableData"/>
      </div>
    </a-card>

    <!-- 同步银行来账弹窗 -->
    <a-modal
        v-model="settleTryModalVisible"
        :title="`流水 - ${settleTryData.bankSerialNo} - 清分预览`"
        :confirm-loading="settleTryonfirmLoading"
        width="80%"
    >
      <a-descriptions :column="2" size="small" bordered>
        <a-descriptions-item label="商户编号">
          {{ settleTryData.merchantNo }}
        </a-descriptions-item>
        <a-descriptions-item label="商户名称">
          {{ settleTryData.merchantName }}
        </a-descriptions-item>
        <a-descriptions-item label="结算账号">
          {{ settleTryData.settleAccountNo }}
        </a-descriptions-item>
        <a-descriptions-item label="结算账户">
          {{ settleTryData.settleAccountName }}
        </a-descriptions-item>
        <a-descriptions-item label="清算金额">
          <balance prefix="¥" :amount="settleTryData.settleAmount" align-right inline/>
        </a-descriptions-item>
      </a-descriptions>
      <!-- 清分明细 -->
      <a-card
          v-if="settleTryData.itemData && settleTryData.itemData.length > 0"
          title="清分明细"
          class="detail-card nested-card"
          :extra="`共 ${settleTryData.itemData.length} 条明细记录`"
      >
        <a-table
            :dataSource="settleTryData.itemData"
            :columns="settleItemColumns"
            :pagination="false"
            size="small"
            bordered
        >
        </a-table>
      </a-card>
      <template slot="footer">
        <a-button key="back" @click="handleCel">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="genPlanBtn(settleTryData.bankSerialNo)">
          确认
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import Balance from "@/view/components/Balance.vue";
import {commonDict} from "@/utils/bizDict/commonDict";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";

export default {
  name: 'bankFlow',
  components: {DepartmentChoose, LcfsPagination, WalletInfo, Balance},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},

      // 筛选参数
      paramsData: {

        bankSerialNo: "",
        merchantNo: "",
        accountNo: "",
        oppAccountNo: "",
        status: "",
        feeStatus: "",
        startDate: "",
        endDate: ""
      },
      tradeDateRange: [],
      // 主商户列表
      mainMerchantList: [],

      // 表格数据
      tableData: [],
      selectedRowKeys: [],
      total: 0,
      pageSizeOptions: ["20", "50", "100"],

      //
      settleTryModalVisible: false,
      settleTryData: {},
      // 清分明细表格列配置
      settleItemColumns: [
        {
          title: '主商户信息',
          dataIndex: 'mainMerchantName',
          width: 180,
          align: "center",
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.mainMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.mainMerchantName}
                  </div>
                </div>

            );
          }
        },
        {
          title: '分商户信息',
          dataIndex: 'splitMerchantName',
          width: 180,
          align: "center",
          customRender: (text, record) => {
            return (

                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.splitMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.splitMerchantName}
                  </div>
                </div>
            );
          }

        },
        {
          title: '付款',
          dataIndex: 'accountName',
          width: 200,
          align: "center",
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNo} accountName={record.accountName} showAccountName={true} size="small"/>);
          }
        },
        {
          title: '收款',
          dataIndex: 'oppAccountName',
          width: 200,
          align: "center",
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.oppAccountNo} accountName={record.oppAccountName} showAccountName={true} size="small"/>);
          }
        },
        {
          title: '清算金额',
          dataIndex: 'amount',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            return <Balance amount={record.amount}/>
          }
        },
        {
          title: '摘要',
          align: "center",
          dataIndex: 'remark',
          width: 120,
        },
      ],
      settleTryonfirmLoading: false,
      syncFormData: {
        startDate: "",
        endDate: "",
        channelNo: ""
      },
      syncFormRules: {
        startDate: [
          {required: true, message: '请选择开始日期', trigger: 'change'}
        ],
        endDate: [
          {required: true, message: '请选择结束日期', trigger: 'change'}
        ]
      },

      // 查看详情
      viewModalVisible: false,
      viewData: null,
      matchResultData: null,

      // 表格列配置
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "流水号",
          dataIndex: "bankSerialNo",
          align: "center",
          width: 180,
          ellipsis: true,
          // customRender: (text, record) => {
          //   if (!text) return "-";
          //   return <a-button type="link" style="color: #1890ff;" onClick={() => this.viewBtn(record)} v-if="$authority('bankFlowView')">{text}</a-button>
          // }
        },
        {
          title: "商户",
          align: "center",
          width: 150,
          customRender: (text, record) => {
            return (
                <a-tooltip>
                  <template slot="title">
                    {record.merchantNo}
                  </template>
                  {record.merchantName}
                </a-tooltip>


            );
          }
        },
        {
          title: "付款人",
          align: "center",
          width: 240,
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.oppAccountNo} accountName={record.oppAccountName} showAccountName={true} isWallet={false}/>);
          }
        },
        {
          title: "来账金额",
          dataIndex: "tradeAmount",
          align: "center",
          width: 120,
          customRender: (text, record) => {
            return <Balance amount={record.tradeAmount} dcflag="d"/>
          }
        },
        {
          title: "清算金额",
          dataIndex: "feeAmount",
          align: "center",
          width: 120,
          customRender: (text, record) => {
            return <Balance amount={(record.tradeAmount - record.feeAmount).toFixed(2)} dcflag="d"/>
          }
        },
        {
          title: '剩余可匹配金额',
          dataIndex: 'remainAmount',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            return <Balance amount={record.remainAmount}/>
          }
        },
        {
          title: "状态",
          dataIndex: "status",
          align: "center",
          width: 100,
          customRender: (text) => {
            return <a-tag color={this.getFlowStatusConfig(text).color}>{this.getFlowStatusConfig(text).label}</a-tag>
          }

        },
        {
          title: "来账时间",
          dataIndex: "tradeTime",
          align: "center",
          width: 150,
          customRender: (text) => {
            if (!text) return "-";
            return this.formatDateTime(text);
          },
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          fixed: "right",
          scopedSlots: {customRender: 'action'}
        }
      ]
    };
  },
  mounted() {

    this.loadMainMerchantList();
  },

  computed: {
    commonDict() {
      return commonDict
    },
  },
  methods: {

    // 获取主商户列表
    async loadMainMerchantList() {
      try {
        const res = await this.api.settleMerchantListApi({
          merchantRelations: '1'
        });
        if (res.code === 200) {
          this.mainMerchantList = res.data || [];
          //初始化筛选参数
          if (this.mainMerchantList.length > 0) {
            this.paramsData.merchantNo = this.mainMerchantList[0]?.merchantNo;
            // 立即查询该商户的数据
            await this.getTableData();
          } else {
            this.$message.warning('暂无商户数据');
          }
        } else {
          this.$message.warning(res.info || '获取商户列表失败');
        }
      } catch (error) {
        console.error('获取商户列表失败:', error);
        this.$message.error('获取商户列表失败');
      }
    },

    // 所选机构触发
    departmentIdchange() {
      console.log("所选机构触发")
    },


    // 获取表格数据
    async getTableData() {
      try {
        const res = await this.api.bankFlowPageApi(
            {
              ...this.pagination,
              ...this.paramsData
            }
        );
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    // 查询
    handleQuery() {
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        bankSerialNo: "",
        merchantNo: "",
        accountNo: "",
        oppAccountNo: "",
        status: "",
        feeStatus: "",
        startDate: "",
        endDate: ""
      };
      this.tradeDateRange = [];
      this.getTableData();
    },

    // 日期范围变化
    onDateChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.paramsData.startDate = dateStrings[0];
        this.paramsData.endDate = dateStrings[1];
      } else {
        this.paramsData.startDate = "";
        this.paramsData.endDate = "";
      }
    },


    // 批量匹配
    async handleBatchMatch() {
      if (this.selectedRowKeys.length === 0) {
        message.warning("请选择要匹配的流水");
        return;
      }

      try {
        const res = await this.api.batchGenerateMatchesApi(this.selectedRowKeys);
        if (res.code === 200) {
          message.success("批量匹配任务已提交");
          this.selectedRowKeys = [];
          this.getTableData();
        } else {
          message.error(res.info || "批量匹配失败");
        }
      } catch (error) {
        console.error("批量匹配失败:", error);
        message.error("批量匹配失败");
      }
    },

    // 单条匹配
    async matchBtn(record) {
      try {
        const res = await this.api.generateMatchesApi(record.bankSerialNo);
        if (res.code === 200) {
          message.success("匹配成功");
          this.getTableData();
        } else {
          message.error(res.info || "匹配失败");
        }
      } catch (error) {
        console.error("匹配失败:", error);
        message.error("匹配失败");
      }
    },

    // 取消匹配
    async cancelMatchBtn(record) {
      this.$confirm({
        title: `确认取消流水 ${record.bankSerialNo} 的匹配吗？`,
        content: '取消匹配后需要重新进行匹配操作。',
        okText: '确认取消',
        cancelText: '取消',
        okType: 'danger',
        onOk: async () => {
          try {
            // 这里需要先获取批次号，实际根据业务逻辑调整
            const matchRes = await this.api.getMatchResultApi(record.bankSerialNo);
            if (matchRes.code === 200 && matchRes.data) {
              const res = await this.api.cancelMatchApi(matchRes.data.batchNo, record.bankSerialNo);
              if (res.code === 200) {
                message.success("取消匹配成功");
                this.getTableData();
              } else {
                message.warning(res.info || "取消匹配失败");
              }
            } else {
              message.warning("获取匹配信息失败");
            }
          } catch (error) {
            console.error("取消匹配失败:", error);
            message.error("取消匹配失败");
          }
        }
      });
    },
    async genPlanTryBtn(record) {
      try {
        this.settleTryonfirmLoading = true;
        const res = await this.api.generateSettlePlantryApi(record.bankSerialNo);
        if (res.code === 200) {

          this.settleTryData = res.data;
          this.settleTryModalVisible = true;
        } else {
          message.warning(res.info || "预览失败");
        }
      } catch (error) {
        console.error("预览失败:", error);
        message.error("预览失败");
      } finally {
        this.settleTryonfirmLoading = false;
      }
    },

    handleCel() {
      this.settleTryModalVisible = false;
      this.settleTryData = {};

    },
    async genPlanBtn(bankSerialNo) {
      try {
        const res = await this.api.generateSettlePlanApi(bankSerialNo);
        if (res.code === 200) {
          this.settleTryModalVisible = false;
          message.success("预结算成功");
          this.getTableData();
        } else {
          message.warning(res.info || "预结算失败");
        }
      } catch (error) {
        console.error("预结算失败:", error);
        message.error("预结算失败");
      }
    },
    async settlementBtn(record) {
      try {
        const res = await this.api.executeSettleByFlowApi(record.bankSerialNo);
        if (res.code === 200) {
          this.getTableData();
        } else {
          message.warning(res.info || "结算失败");
        }
      } catch (error) {
        console.error("结算失败:", error);
        message.error("结算失败");
      }

    },

    async viewBtn(record) {
      //跳转到/slt/bankFlow/detail
      this.$router.push({
        path: '/slt/bankFlow/detail',
        query: {
          bankSerialNo: record.bankSerialNo
        }
      })

    },

    // 表格行选择
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    // 状态配置
    getFlowStatusConfig(status) {
      return commonDict.flow_status[status] || commonDict.flow_status.default;

    },

    getFeeStatusConfig(status) {
      return commonDict.flowFee_status[status] || commonDict.flowFee_status.default;
    },


    // 日期时间格式化
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    // 分页相关方法
    onShowSizeChange(current, pageSize) {
      this.paramsData.pageNo = current;
      this.paramsData.pageSize = pageSize;
      this.getTableData();
    },

    pagechange(val) {
      this.paramsData.pageNo = val;
      this.getTableData();
    },

    Homepage() {
      if (this.total === 0) return;
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    Trailingpage() {
      if (this.total === 0) return;
      this.paramsData.pageNo = Math.ceil(this.total / this.paramsData.pageSize);
      this.getTableData();
    },

    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .ant-btn {
    margin: 0 8px;
  }

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    border: 1px solid #d9d9d9;
    width: 60px;
  }
}

.bank-flow-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .ant-card-head {
      min-height: 40px;
      padding: 0 12px;

      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        padding: 8px 0;
      }
    }

    /deep/ .ant-card-body {
      padding: 12px;
    }
  }

  .detail-value {
    font-weight: 500;
    color: #333;
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
}

@media (max-width: 768px) {
  .bank-flow-detail {
    .detail-section {
      /deep/ .ant-descriptions-bordered .ant-descriptions-item {
        padding: 8px 12px;
      }
    }
  }
}

/deep/ .ant-descriptions-item-label {
  font-weight: bold;
  background-color: #fafafa;
}

/deep/ .ant-card-head-title {
  .top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;

    .dianshang {
      margin-left: 50px;
    }
  }
}
</style>